module.exports = "pegasus_template/assets/background-patterns/shl.png";